import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { SnackbarService, Vue3Snackbar } from 'vue3-snackbar';
import { createI18n } from 'vue-i18n';

import App from './App.vue';
import router from './router';
import ApiClient from './plugins/ApiClient';
import 'vue3-snackbar/styles';
import localMessages from './lib/i18n/index.js';
import 'animate.css';

if (!window.____sgi_pdf_converter) {
  const app = createApp(App);

  const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: localMessages,
  });

  app
    .use(createPinia())
    .use(router)
    .use(i18n)
    .use(ApiClient)
    .use(SnackbarService);

  app.component('Vue3Snackbar', Vue3Snackbar);

  app.mount('#app');
}
